/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTeamsInvitationsInvitationidDeclineMutationResponse,
  PostTeamsInvitationsInvitationidDeclinePathParams,
  PostTeamsInvitationsInvitationidDecline400,
  PostTeamsInvitationsInvitationidDecline401,
  PostTeamsInvitationsInvitationidDecline404,
  PostTeamsInvitationsInvitationidDecline500,
} from "../types/PostTeamsInvitationsInvitationidDecline.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTeamsInvitationsInvitationidDeclineMutationKey = () =>
  [{ url: "/teams/invitations/:invitationId/decline" }] as const;

export type PostTeamsInvitationsInvitationidDeclineMutationKey = ReturnType<
  typeof postTeamsInvitationsInvitationidDeclineMutationKey
>;

/**
 * @description Отклоняет приглашение в команду.
 * Статус приглашения изменяется на Declined.
 * Капитан команды получает уведомление об отклонении.
 * @summary Отклонить приглашение в команду
 * {@link /teams/invitations/:invitationId/decline}
 */
export async function postTeamsInvitationsInvitationidDecline(
  invitationId: PostTeamsInvitationsInvitationidDeclinePathParams["invitationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostTeamsInvitationsInvitationidDeclineMutationResponse,
    ResponseErrorConfig<
      | PostTeamsInvitationsInvitationidDecline400
      | PostTeamsInvitationsInvitationidDecline401
      | PostTeamsInvitationsInvitationidDecline404
      | PostTeamsInvitationsInvitationidDecline500
    >,
    unknown
  >({
    method: "POST",
    url: `/teams/invitations/${invitationId}/decline`,
    ...requestConfig,
  });
  return res;
}

export function postTeamsInvitationsInvitationidDeclineMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = postTeamsInvitationsInvitationidDeclineMutationKey();
  return mutationOptions<
    ResponseConfig<PostTeamsInvitationsInvitationidDeclineMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInvitationsInvitationidDecline400
      | PostTeamsInvitationsInvitationidDecline401
      | PostTeamsInvitationsInvitationidDecline404
      | PostTeamsInvitationsInvitationidDecline500
    >,
    {
      invitationId: PostTeamsInvitationsInvitationidDeclinePathParams["invitationId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ invitationId }) => {
      return postTeamsInvitationsInvitationidDecline(invitationId, config);
    },
  });
}

/**
 * @description Отклоняет приглашение в команду.
 * Статус приглашения изменяется на Declined.
 * Капитан команды получает уведомление об отклонении.
 * @summary Отклонить приглашение в команду
 * {@link /teams/invitations/:invitationId/decline}
 */
export function usePostTeamsInvitationsInvitationidDecline<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTeamsInvitationsInvitationidDeclineMutationResponse>,
      ResponseErrorConfig<
        | PostTeamsInvitationsInvitationidDecline400
        | PostTeamsInvitationsInvitationidDecline401
        | PostTeamsInvitationsInvitationidDecline404
        | PostTeamsInvitationsInvitationidDecline500
      >,
      {
        invitationId: PostTeamsInvitationsInvitationidDeclinePathParams["invitationId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postTeamsInvitationsInvitationidDeclineMutationKey();

  const baseOptions = postTeamsInvitationsInvitationidDeclineMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTeamsInvitationsInvitationidDeclineMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInvitationsInvitationidDecline400
      | PostTeamsInvitationsInvitationidDecline401
      | PostTeamsInvitationsInvitationidDecline404
      | PostTeamsInvitationsInvitationidDecline500
    >,
    {
      invitationId: PostTeamsInvitationsInvitationidDeclinePathParams["invitationId"];
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTeamsInvitationsInvitationidDeclineMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInvitationsInvitationidDecline400
      | PostTeamsInvitationsInvitationidDecline401
      | PostTeamsInvitationsInvitationidDecline404
      | PostTeamsInvitationsInvitationidDecline500
    >,
    {
      invitationId: PostTeamsInvitationsInvitationidDeclinePathParams["invitationId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTeamsInvitationsInvitationidDeclineMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInvitationsInvitationidDecline400
      | PostTeamsInvitationsInvitationidDecline401
      | PostTeamsInvitationsInvitationidDecline404
      | PostTeamsInvitationsInvitationidDecline500
    >,
    {
      invitationId: PostTeamsInvitationsInvitationidDeclinePathParams["invitationId"];
    },
    TContext
  >;
}
